// extracted by mini-css-extract-plugin
export default {"root":"ThemePreview__root--1vNqD"};